import UserState from '../user_state';
export default {
  props: ['coursework'],
  template: '#instructions_step_template',
  data() {
    return {
      number: 0,
      name: 'Instructions',
      task: 'Read Instructions',
      isInView: false,
    };
  },
  computed: {
    isVisible() {
      return true;
    },
    isActive() {
      return this.isVisible;
    },
    isComplete() {
      return this.coursework.has_viewed_instructions;
    }
  },
  methods: {
    markCompleted() {
      let self = this;
      if (self.isVisible && !self.isComplete) {
        if (Kadenze.UIUtil.isInFullView(self.$el)) {
          UserState.stepCompleted(self.coursework.id, 'instructions').done(function () {
            self.coursework.has_viewed_instructions = true;
          });
        } else {
          $(window).off('scroll.coursework_instructions').on('scroll.coursework_instructions', function() {
            if(Kadenze.UIUtil.isInView(self.$el)) {
              UserState.stepCompleted(self.coursework.id, 'instructions').done(function () {
                self.coursework.has_viewed_instructions = true;
              });
              $(window).off('scroll.coursework_instructions');
            }
          });
        }
      }
    }
  },
  created() {
    this.$parent.steps.push(this);
  },
  mounted() {
    this.markCompleted();
  }
};
